const pageNameKey = "ticketCard";

export const ticketCardEn = {
  [pageNameKey]: {
    status: {
      new: "NEW",
      open: "OPEN",
      pending: "PENDING",
      solved: "SOLVED",
      hold: "HOLD",
    },
    noCompanyInformation: "No company information",
    noMachineInformation: "No machine information",
    by: "by",
    priorityIconAltText: "Priority icon",
    companyIconAltText: "Company icon",
    sourceIconAltText: "Source icon",
    aiChatbotIconAltText: "AI chatbot icon",
    unknownUser: "Unknown user",
  },
};

export const ticketCardPtBr = {
  [pageNameKey]: {
    status: {
      new: "NOVO",
      open: "ABERTO",
      pending: "PENDENTE",
      solved: "RESOLVIDO",
      hold: "EM ESPERA",
    },
    noCompanyInformation: "Nenhuma informação da empresa",
    noMachineInformation: "Nenhuma informação da máquina",
    by: "por",
    priorityIconAltText: "Ícone de prioridade",
    companyIconAltText: "Ícone da empresa",
    sourceIconAltText: "Ícone da fonte",
    aiChatbotIconAltText: "Ícone do chatbot de IA",
    unknownUser: "Usuário desconhecido",
  },
};

export const ticketCardDe = {
  [pageNameKey]: {
    status: {
      new: "NEU",
      open: "OFFEN",
      pending: "AUSSTEHEND",
      solved: "GELÖST",
      hold: "WARTEND",
    },
    noCompanyInformation: "Keine Firmeninformationen",
    noMachineInformation: "Keine Maschineninformationen",
    by: "von",
    priorityIconAltText: "Prioritätsicon",
    companyIconAltText: "Firmenicon",
    sourceIconAltText: "Quellenicon",
    aiChatbotIconAltText: "KI-Chatbot-Icon",
    unknownUser: "Unbekannter Benutzer",
  },
};

export const ticketCardZhHans = {
  [pageNameKey]: {
    status: {
      new: "新建",
      open: "打开",
      pending: "处理中",
      solved: "已解决",
      hold: "等待中",
    },
    noCompanyInformation: "没有公司信息",
    noMachineInformation: "没有机器信息",
    by: "由",
    priorityIconAltText: "优先级图标",
    companyIconAltText: "公司图标",
    sourceIconAltText: "来源图标",
    aiChatbotIconAltText: "AI 聊天机器人图标",
    unknownUser: "未知用户",
  },
};

export const ticketCardIt = {
  [pageNameKey]: {
    status: {
      new: "NUOVO",
      open: "APERTO",
      pending: "IN ATTESA",
      solved: "RISOLTO",
      hold: "IN SOSPESO",
    },
    noCompanyInformation: "Nessuna informazione sull'azienda",
    noMachineInformation: "Nessuna informazione sulla macchina",
    by: "da",
    priorityIconAltText: "Icona di priorità",
    companyIconAltText: "Icona aziendale",
    sourceIconAltText: "Icona macchina",
    aiChatbotIconAltText: "Icona chatbot IA",
    unknownUser: "Utente sconosciuto",
  },
};

export const ticketCardEs = {
  [pageNameKey]: {
    status: {
      new: "NUEVO",
      open: "ABIERTO",
      pending: "PENDIENTE",
      solved: "RESUELTO",
      hold: "EN PAUSA",
    },
    noCompanyInformation: "No hay información de la empresa",
    noMachineInformation: "No hay información de la máquina",
    by: "por",
    priorityIconAltText: "Icono de prioridad",
    companyIconAltText: "Icono de la empresa",
    sourceIconAltText: "Icono de origen",
    aiChatbotIconAltText: "Icono del chatbot de IA",
    unknownUser: "Usuario desconocido",
  },
};

export const ticketCardNl = {
  [pageNameKey]: {
    by: "door",
    companyIconAltText: "Bedrijfspictogram",
    noCompanyInformation: "Geen bedrijfsinformatie",
    noMachineInformation: "Geen machine-informatie",
    priorityIconAltText: "Prioriteitspictogram",
    sourceIconAltText: "Bronpictogram",
    aiChatbotIconAltText: "AI-chatbotpictogram",
    status: {
      new: "NIEUW",
      open: "OPEN",
      pending: "IN AFWACHTING",
      solved: "OPGELOST",
      hold: "WACHTEND",
    },
    unknownUser: "Onbekende gebruiker",
  },
};

export const ticketCardTr = {
  [pageNameKey]: {
    by: "ile",
    companyIconAltText: "Şirket simgesi",
    status: {
      hold: "TUTMAK",
      new: "YENİ",
      open: "AÇIK",
      pending: "ASKIDA OLMASI",
      solved: "ÇÖZÜLDÜ",
    },
    noCompanyInformation: "Şirket bilgisi yok",
    noMachineInformation: "Makine bilgisi yok",
    priorityIconAltText: "Öncelik simgesi",
    sourceIconAltText: "Kaynak simgesi",
    aiChatbotIconAltText: "Yapay zekâ sohbet botu simgesi",
    unknownUser: "Bilinmeyen kullanıcı",
  },
};
